// extracted by mini-css-extract-plugin
export var CTAContainer = "CTA-module--CTAContainer--1mOPu";
export var Left = "CTA-module--Left--2WjLO";
export var Right = "CTA-module--Right--2YbHs";